import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-onboarding-action-dropdown',
  templateUrl: './onboarding-action-dropdown.component.html',
  styleUrls: ['./onboarding-action-dropdown.component.css']
})
export class OnboardingActionDropdownComponent {
  @Input() source: string = '';
  @Input() entity: any;
  @Input() loading: any;


  @Output() logs = new EventEmitter<any>();
  @Output() edit = new EventEmitter<any>();
  @Output() sync = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() downloadInspectionForm = new EventEmitter<any>();
  @Output() raiseTicket = new EventEmitter<any>();
}

